import { Flex, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { Text } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import ClockIcon from '@atlaskit/icon/core/clock';

interface ClassTimeSlotProps {
  iconMonth: string;
  iconDay: string;
  titleDate: string;
  subtitleTime: string;
}

export const ClassTimeSlot = ({ iconMonth, iconDay, titleDate, subtitleTime }: ClassTimeSlotProps) => {
  return (
    <div css={containerStyles}>
      <div css={calendarStyles}>
        <div css={calendarMonthStyles}>
          <p>{iconMonth}</p>
        </div>
        <div css={calendarDayStyles}>
          <p>{iconDay}</p>
        </div>
      </div>
      <Stack space="space.050" alignInline="start">
        <Flex alignItems="center" gap="space.050">
          <ClockIcon label="clock" color={token('color.text.brand')} />
          <Text>{subtitleTime}</Text>
        </Flex>
        <Text size="regular" fontWeight="regular" color={token('color.text.subtle')}>
          {titleDate}
        </Text>
      </Stack>
    </div>
  );
};

const containerStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: token('space.200'),
  flexWrap: 'nowrap',
});

const calendarStyles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '3.5rem',
  padding: '.25rem 0',
  flexShrink: 0,
  borderRadius: '4px',
});

const calendarMonthStyles = css({
  display: 'flex',
  maxHeight: '1rem',
  padding: '1rem',
  paddingBottom: '.75rem',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1rem',
  alignSelf: 'stretch',
  borderRadius: '4px 4px 0 0',
  background: token('color.border.brand'),
  p: {
    color: token('color.text.inverse'),
    textAlign: 'center',
    fontFamily: 'Charlie Display',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '1.5rem',
  },
});

const calendarDayStyles = css({
  display: 'flex',
  maxHeight: '2rem',
  padding: '1rem',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1rem',
  alignSelf: 'stretch',
  borderRadius: '0 0 4px 4px',
  border: `2px solid ${token('color.border.brand')}`,
  background: '#FFF',
  p: {
    color: token('color.text'),
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '1.25rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '2.5rem',
  },
});
